import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, CanMatchFn, Route, Router, UrlSegment, UrlTree } from '@angular/router';
import { LicenseManagerService } from '@uigy/modules/license/license-manager.service';
import { first, map, switchMap } from 'rxjs/operators';
import { AppInitializationService } from '@uigy/shared/services/app-initialization.service';
import { RoutesStatesNamesEnum } from '@uigy/shared/enums/routesStatesNames.enum';
import { Capability, LicenseStatus } from '@uigy/generated/graphql';
import { CapabilitiesService } from '@uigy/shared/capabilities/capabilities.service';
import { Store } from '@ngrx/store';
import { LicenseStatusUpdated } from '@uigy/store/actions/general.actions';
import { IemService } from '@uigy/shared/services/iem.service';

export const LicensedGuard: CanActivateFn | CanActivateChildFn | CanMatchFn = () => {
  const appInitializationService = inject(AppInitializationService);
  const licenseManagerService = inject(LicenseManagerService);
  const capabilitiesService = inject(CapabilitiesService);
  const store = inject(Store);
  const iemService = inject(IemService);
  const router = inject(Router);

  const LICENSE_ACTIVATION: UrlTree = router.createUrlTree([RoutesStatesNamesEnum.licenseActivation]);
  const LICENSE_EXPIRED: UrlTree = router.createUrlTree([RoutesStatesNamesEnum.licenseExpired]);

  return appInitializationService.appInitialized.pipe(
    switchMap(() => licenseManagerService.getLicenseStatus()),
    first(),
    map((licenseStatus: LicenseStatus) => {
      store.dispatch(new LicenseStatusUpdated(licenseStatus));
      const licenseUninitialized = licenseStatus === LicenseStatus.Uninitialized || licenseStatus === LicenseStatus.WaitingForActivation;
      const licenseExpired = licenseStatus === LicenseStatus.MaintenanceExpired || licenseStatus === LicenseStatus.SubscriptionExpired || licenseStatus === LicenseStatus.AssetCountExceeded;
      const canAccessFromICP = iemService.isIcpViewInEm() || !capabilitiesService.capableOf(Capability.SystemSettings);
      if (licenseUninitialized) {
        return LICENSE_ACTIVATION;
      } else if (licenseExpired && canAccessFromICP) {
        return LICENSE_EXPIRED;
      }

      return true;
    })
  );
};
